<script setup>
import { Head,  Link } from '@inertiajs/inertia-vue3';
import {ref, onMounted, reactive} from "vue";
import FlashMessageTailwind from "../Components/FlashMessageTailwind.vue";



const props = defineProps({
  brandInfo: {
    type: Object,
    required: true,
    default: null
  },

})

const mobileNavOpen = ref(false)
const mobileNav = ref(null)
const hamburger = ref(null)
const logoImg = ref(null)
const logoLoadFailed = ref(false)
const alternativePaths = [
  '/images/logo/business_compliance_services_logo.png',
  '/images/logo.png',
]
let currentPathIndex = 0

// Handle image loading errors
const handleImageError = () => {
  // Try next alternative path if available
  if (currentPathIndex < alternativePaths.length) {
    if (logoImg.value) {
      logoImg.value.src = alternativePaths[currentPathIndex]
      currentPathIndex++
    }
  } else {
    // If all alternatives fail, show text instead
    logoLoadFailed.value = true
  }
}

// close on click outside
const clickHandler = ({ target }) => {
    if (!mobileNavOpen.value || mobileNav.value.contains(target) || hamburger.value.contains(target)) return
    mobileNavOpen.value = false
}

// close if the esc key is pressed
const keyHandler = ({ keyCode }) => {
    if (!mobileNavOpen.value || keyCode !== 27) return
    mobileNavOpen.value = false
}

onMounted(() => {
    document.addEventListener('click', clickHandler)
    document.addEventListener('keydown', keyHandler)
})

</script>

<template>
  <header class="flex flex-col w-full z-30 bg-slate-900">
    <nav class="flex container items-center justify-between px-4 py-5 mx-auto max-w-6xl">
      <!-- Logo -->
      <div class="flex-shrink-0">
        <a :href="brandInfo.url">
          <img
            v-if="brandInfo.header.image"
            :src="brandInfo.header.image"
            alt="logo"
            style="height: 48px; width: auto;"
            @error="handleImageError"
            ref="logoImg"
          >
          <span v-if="!brandInfo.header.image || logoLoadFailed" class="text-white font-bold text-lg">
            {{ brandInfo.header.title || 'Business Compliance Services' }}
          </span>
        </a>
      </div>

      <!-- Desktop navigation -->
      <ul class="flex-wrap justify-center hidden md:flex">
        <li v-for="link in brandInfo.header.navigation" :key="link.title" class="p-2 px-4 font-medium text-white hover:text-[rgb(var(--brand-accent-400))] transition duration-200 text-nowrap">
          <a :href="link.url">{{ link.title }}</a>
        </li>
      </ul>

      <!-- Mobile hamburger button -->
      <button
        ref="hamburger"
        class="z-50 p-2 border border-slate-600 rounded-lg md:hidden focus:outline-none ml-auto"
        @click="mobileNavOpen = !mobileNavOpen"
      >
        <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            v-show="!mobileNavOpen"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
          <path
            v-show="mobileNavOpen"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </nav>

    <!-- Mobile sidebar navigation -->
    <div
      ref="mobileNav"
      v-show="mobileNavOpen"
      class="z-40 w-full overflow-auto bg-slate-800 md:hidden"
    >
      <ul class="flex flex-col p-4 space-y-4">
        <li v-for="link in brandInfo.header.navigation" :key="link.title" class="p-2 px-4 font-medium text-white hover:text-[rgb(var(--brand-accent-400))] transition duration-200 text-nowrap">
          <a :href="link.url">{{ link.title }}</a>
        </li>
      </ul>
    </div>

    <FlashMessageTailwind
        :msgSuccess="$page.props.flash.success"
        :msgError="$page.props.flash.error"
        :msgMessage="$page.props.flash.message"
    ></FlashMessageTailwind>
  </header>
</template>
